import React, { Component } from "react"
import OkDialog from "./OkDialog"

const apiUrl = "https://apikey.idexo.io/"

class Apikeys extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dialogOpen: false,
            dialogTitle: "Response received",
            dialogMsg: ""
        }
        this.dialogClose = this.dialogClose.bind(this)
        this.dialogOpen = this.dialogOpen.bind(this)
        this.submitEmail = this.submitEmail.bind(this)
        this.submitKey = this.submitKey.bind(this)
    }

    dialogClose() {
        this.setState({ dialogOpen: false })
    }
    dialogOpen(message) {
        this.setState({
            dialogOpen: true,
            dialogMsg: message
        })
    }

    submitEmail(event) {
        if (event.key === "Enter") {
            let input = document.getElementById("emailInput")
            let span = document.getElementById("emailSpan")
            input.disabled = true
            span.className = "bx bx-hourglass"
            fetch(apiUrl + "?email=" + encodeURIComponent(input.value))
                .then((res) => res.json())
                .then((data) => {
                    console.log("Success: ", data)
                    input.disabled = false
                    setTimeout(() => (span.className = "bx bx-mail-send"), 500)
                    if (data.error) this.dialogOpen("Things are not going your way, server says: " + data.error)
                    else this.dialogOpen("Email on the way, check on that to complete the process... ")
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }

    submitKey(event) {
        if (event.key === "Enter") {
            let input = document.getElementById("keyInput")
            let span = document.getElementById("keySpan")
            input.disabled = true
            span.className = "bx bx-hourglass"
            fetch(apiUrl + "?id=" + input.value)
                .then((res) => res.json())
                .then((data) => {
                    input.disabled = false
                    setTimeout(() => (span.className = "bx bx-key"), 500)
                    if (data.error) this.dialogOpen("Things are not going your way, server says: " + data.error)
                    else this.dialogOpen("Process complete, here is your apikey: " + data.data)
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="content">
                    <div className="app-email d-lg-block">
                        To request an api key enter email here:
                        <div className="position-relative">
                            <input id="emailInput" type="text" className="form-control" onKeyPress={this.submitEmail} />
                            <span id="emailSpan" className="bx bx-mail-send"></span>
                        </div>
                    </div>
                    <br />
                    <div className="app-key d-lg-block">
                        If you received an email enter confirmation id here:
                        <div className="position-relative">
                            <input id="keyInput" type="text" className="form-control" onKeyPress={this.submitKey} />
                            <span id="keySpan" className="bx bx-key"></span>
                        </div>
                    </div>
                </div>

                <OkDialog
                    open={this.state.dialogOpen}
                    title={this.state.dialogTitle}
                    message={this.state.dialogMsg}
                    okClick={this.dialogClose}
                />
            </React.Fragment>
        )
    }
}

export default Apikeys
